
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summarization/keywords-extraction",
      function () {
        return require("private-next-pages/summarization/keywords-extraction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summarization/keywords-extraction"])
      });
    }
  